"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var react_2 = require("react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledButton = (0, react_1.styled)("button", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    padding: "8px 12px",
    width: "fit-content",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    border: "none",
    cursor: "pointer",
    gap: "6px",
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    variants: {
        color: {
            gray: {
                background: stitches_config_1.theme.colors.gray3,
                borderColor: stitches_config_1.theme.colors.gray7,
                color: stitches_config_1.theme.colors.gray12,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.gray4,
                },
                "&:active": {
                    backgroundColor: stitches_config_1.theme.colors.gray5,
                },
            },
            brand: {
                background: stitches_config_1.theme.colors.blue9,
                borderColor: stitches_config_1.theme.colors.blue7,
                color: stitches_config_1.theme.colors.blue11,
            },
            critical: {
                background: stitches_config_1.theme.colors.red9,
                borderColor: stitches_config_1.theme.colors.red7,
                color: stitches_config_1.theme.colors.red11,
            },
        },
        variant: {
            solid: {},
            outline: {
                background: stitches_config_1.theme.colors.white,
                borderWidth: "1px",
                borderStyle: "solid",
            },
            ghost: {
                background: "transparent",
            },
            inline: {
                padding: "0px",
                background: "transparent",
            },
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
    compoundVariants: [
        {
            variant: "inline",
            color: "gray",
            css: {
                color: stitches_config_1.theme.colors.gray11,
                background: "transparent",
                "&:hover": {
                    color: stitches_config_1.theme.colors.gray12,
                    background: "transparent",
                },
            },
        },
        {
            variant: "outline",
            color: "gray",
            css: {
                background: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.gray2,
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
                "&:active": {
                    backgroundColor: stitches_config_1.theme.colors.gray3,
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
            },
        },
        {
            variant: "ghost",
            color: "gray",
            css: {
                background: "transparent",
            },
        },
        {
            variant: "outline",
            color: "brand",
            css: {
                background: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.blue2,
                    borderColor: stitches_config_1.theme.colors.blue8,
                },
            },
        },
        {
            variant: "inline",
            color: "brand",
            css: {
                background: "transparent",
                "&:hover": {
                    color: stitches_config_1.theme.colors.gray12,
                },
            },
        },
        {
            variant: "solid",
            color: "brand",
            css: {
                color: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.blue10,
                },
            },
        },
        {
            variant: "ghost",
            color: "brand",
            css: {
                background: "transparent",
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.blue4,
                },
            },
        },
        {
            variant: "outline",
            color: "critical",
            css: {
                background: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.red2,
                    borderColor: stitches_config_1.theme.colors.red8,
                },
            },
        },
        {
            variant: "solid",
            color: "critical",
            css: {
                color: stitches_config_1.theme.colors.white,
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.red10,
                },
            },
        },
        {
            variant: "inline",
            color: "critical",
            css: {
                background: "transparent",
                "&:hover": {
                    color: stitches_config_1.theme.colors.gray12,
                },
            },
        },
        {
            variant: "ghost",
            color: "critical",
            css: {
                background: "transparent",
                "&:hover": {
                    backgroundColor: stitches_config_1.theme.colors.red4,
                },
            },
        },
    ],
    defaultVariants: {
        color: "gray",
        variant: "solid",
    },
});
var className = "button";
exports.Button = (0, react_2.forwardRef)(function (props, ref) {
    return ((0, jsx_runtime_1.jsxs)(StyledButton, __assign({ className: "".concat(className, " ").concat(props.className), disabled: props.disabled, onClick: props.onClick }, props, { type: props.type, color: props.color, fullWidth: props.fullWidth, variant: props.variant, ref: ref }, { children: [props.startIcon && props.startIcon, props.text && (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.text })), props.endIcon && props.endIcon] })));
});
exports.Button.toString = function () { return ".".concat(className); };
//# sourceMappingURL=Button.js.map